/**
 * Hand a text file to the user through the browser's own download path.
 *
 * The object URL is revoked on the next tick rather than immediately: revoking
 * before the click has been dispatched cancels the download in Chromium, which
 * is the engine the Electron renderer runs on.
 */
export function downloadTextFile(filename: string, contents: string, mimeType: string): void {
  const blob = new Blob([contents], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
